import { dispatch } from '../store';

const { createSlice } = require('@reduxjs/toolkit');

const initialState = {
  voucherCode: undefined,
  isGivingBasketOpen: false,
  isGiftCardOpen: false,
  isOpen: false,
  isValid: false,
  intent: undefined,
};

const slice = createSlice({
  name: 'voucher',
  initialState,
  reducers: {
    setVoucherCode(state, action) {
      state.voucherCode = action.payload;
    },

    setIsGivingBasketOpen(state, action) {
      state.isGivingBasketOpen = action.payload;
    },

    setIsGiftCardOpen(state, action) {
      state.isGiftCardOpen = action.payload;
    },

    setIsOpen(state, action) {
      state.isOpen = action.payload;
    },

    setIsValid(state, action) {
      state.isValid = action.payload;
    },

    setIntent(state, action) {
      state.intent = action.payload;
    },
  },
});

export default slice.reducer;

// export const { setIsGiftCardOpen, setIsGivingBasketOpen, setVoucherCode, setIsOpen, setIsValid } = slice.actions;

export function setIsGiftCardOpenEvent(isOpen) {
  return async () => {
    dispatch(slice.actions.setIsGiftCardOpen(isOpen));
  };
}

export function setIsGivingBasketOpenEvent(isOpen) {
  return async () => {
    dispatch(slice.actions.setIsGivingBasketOpen(isOpen));
  };
}

export function setVoucherCodeEvent(isOpen) {
  return async () => {
    dispatch(slice.actions.setVoucherCode(isOpen));
  };
}

export function setIsOpenEvent(isOpen) {
  return async () => {
    dispatch(slice.actions.setIsOpen(isOpen));
  };
}

export function setIsValidEvent(isOpen) {
  return async () => {
    dispatch(slice.actions.setIsValid(isOpen));
  };
}

export function setIntentEvent(intent) {
  return async () => {
    dispatch(slice.actions.setIntent(intent));
  };
}